/**
 * Illustrative task data for the homepage Project Management preview.
 *
 * Not real customer data. Offsets are in days relative to "today" so the demo
 * timeline stays current no matter when the page is viewed — a fixed date range
 * would drift into the past and read as a stale screenshot.
 *
 * Status colours mirror the real STATUSES palette in
 * src/simulation/management/managementConstants.js. They are duplicated rather
 * than imported so the marketing bundle doesn't pull in the app's task module.
 */

export const DEMO_STATUS_COLORS = {
  "Not Started": "#757575",
  "In Progress": "#2196F3",
  "In Review": "#00BCD4",
  Scheduled: "#FFC107",
  Blocked: "#F44336",
  Done: "#388E3C",
};

/**
 * depth    — indent level in the task tree (0 = top level).
 * step     — "sequential" (→, must run in order) or "concurrent" (⇉).
 * from/to  — day offsets from today; a milestone uses `at` instead.
 * after    — id of the task this one depends on (drives the arrows).
 * critical — on the longest dependency chain driving the end date.
 */
export const DEMO_TASKS = [
  { id: "char", name: "Site Characterisation", depth: 0, step: "sequential", status: "Done", from: -46, to: -18, critical: true },
  { id: "cols", name: "Column Leach Test Program", depth: 1, step: "concurrent", status: "Done", from: -44, to: -24, assignee: "R. Okonkwo" },
  { id: "block", name: "Block Model Import", depth: 1, step: "concurrent", status: "Done", from: -38, to: -18, assignee: "M. Alvarez" },

  { id: "cal", name: "Model Calibration", depth: 0, step: "sequential", status: "In Progress", from: -16, to: 14, after: "char", critical: true },
  { id: "kin", name: "Kinetic Parameter Fitting", depth: 1, step: "concurrent", status: "In Progress", from: -16, to: 4, assignee: "R. Okonkwo", critical: true },
  { id: "hyd", name: "Hydrodynamic Calibration", depth: 1, step: "concurrent", status: "In Review", from: -8, to: 14, assignee: "S. Whitfield" },

  { id: "base", name: "Baseline Forecast Run", depth: 0, step: "sequential", status: "Scheduled", from: 16, to: 38, after: "cal", assignee: "M. Alvarez", critical: true },
  { id: "alt", name: "Alternative Stacking Scenarios", depth: 0, step: "concurrent", status: "Not Started", from: 24, to: 58, after: "cal" },
  { id: "rev", name: "Q3 Recovery Review", depth: 0, step: "sequential", status: "Blocked", from: 40, to: 62, after: "base", assignee: "S. Whitfield", critical: true },
  { id: "board", name: "Board Submission", depth: 0, milestone: true, status: "Scheduled", at: 66, after: "rev", critical: true },
];

/** Timeline window, in days either side of today. */
export const DEMO_RANGE = { before: 54, after: 78 };
